var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.weapons,"items-per-page":500},scopedSlots:_vm._u([{key:"item.baseDamageType",fn:function(ref){
var item = ref.item;
return [_c('v-img',{attrs:{"src":_vm.resolveDamageTypeAsset(item.baseDamageType),"height":"16px","width":"16px"}})]}},{key:"item.extraDamageType",fn:function(ref){
var item = ref.item;
return [(item.extraDamage > 0)?_c('v-img',{attrs:{"src":_vm.resolveDamageTypeAsset(item.extraDamageType),"height":"16px","width":"16px"}}):_vm._e()]}},{key:"item.extraDamage",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s((item.extraDamage > 0) ? item.extraDamage : '-')+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }